import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'

const config = {
  api: 'https://api.plowe.studio/rkd',
  gallery: 'https://gallery.plowe.studio',
}

config.install = function () {
  Object.defineProperty(Vue.prototype, '$config', {
    get () { return config },
  })
}

Vue.use(config)
Vue.use(VueResource)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
